import '@emotion/react';
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var className = 'input-structure';
var baseStyles = process.env.NODE_ENV === "production" ? {
  name: "t8jny4",
  styles: "display:flex;flex-direction:column;gap:var(--spacing-l1);.label-row{display:flex;justify-content:space-between;}"
} : {
  name: "zmtoe2-baseStyles",
  styles: "display:flex;flex-direction:column;gap:var(--spacing-l1);.label-row{display:flex;justify-content:space-between;};label:baseStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export { baseStyles, className };
